import { useState, useEffect, useRef, useContext } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { Form, Button, Alert } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../components/Loader.js'
import { login } from '../actions/userActions.js'
import FormContainer from '../components/FormContainer.js'
import { USER_LOGIN_RESET } from '../constants/userConstants.js'
import { ThemeContext } from '../components/ThemeContext.js'

// LoginScreen component handles user login functionality
const LoginScreen = () => {
  const { theme } = useContext(ThemeContext)

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [message, setMessage] = useState(null)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const inputRef = useRef()

  const userLogin = useSelector((state) => state.userLogin)
  const { loading, error, userInfo } = userLogin

  // useEffect to handle user login state and account status
  useEffect(() => {
    if (userInfo && userInfo.isDisabled === true) {
      setMessage('Your account has been disabled. Please contact support.')
      dispatch({ type: USER_LOGIN_RESET })
      setEmail('')
      setPassword('')
      if (inputRef.current) {
        inputRef.current.focus()
      }
    } else if (userInfo) {
      navigate('/dashboard')
    }
  }, [navigate, userInfo, dispatch])

  // Focus email input when landing on the page and not redirecting.
  useEffect(() => {
    if (!userInfo && !loading && inputRef.current) {
      requestAnimationFrame(() => inputRef.current?.focus())
    }
  }, [userInfo, loading])

  // submitHandler dispatches the login action with email and password when the form is submitted
  const submitHandler = (e) => {
    e.preventDefault()
    if (!email || !password) {
      setMessage('Please enter your email and password.')
      return
    }
    dispatch(login(email, password))
  }

  // Render the login form with error messages, loading state, and navigation links
  return (
    <>
      <FormContainer
        className='p-4'
        style={{ backgroundColor: theme.background, borderRadius: '8px' }}
      >
        <br />
        <h3 style={{ color: theme.text }}>User Login</h3>

        {error && (
          <Alert dismissible variant='danger'>
            Invalid email or password
          </Alert>
        )}
        {message && (
          <Alert dismissible variant='warning' onClose={() => setMessage(null)}>
            {message}
          </Alert>
        )}
        {loading && <Loader />}
        <Form onSubmit={submitHandler}>
          <Form.Group className='mb-3' controlId='email'>
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              ref={inputRef}
              autoFocus
              type='email'
              placeholder='Enter email'
              value={email}
              autoComplete='email'
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>
          <Form.Group className='mb-3' controlId='password'>
            <Form.Label>Password</Form.Label>
            <Form.Control
              type='password'
              placeholder='Enter Password (minimum 6 characters)'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>

          <Button
            type='submit'
            variant='outline-primary'
            disabled={loading}
            style={{
              borderColor: theme.accent,
              color: theme.accent,
              backgroundColor: 'transparent'
            }}
          >
            Sign In
          </Button>
          <Button
            as={Link}
            to='/register'
            variant='outline-primary'
            style={{
              borderColor: theme.accent,
              color: theme.accent,
              backgroundColor: 'transparent'
            }}
          >
            Register Here
          </Button>
        </Form>
      </FormContainer>
    </>
  )
}

export default LoginScreen
